export const mockWorkOrdersByVehicle = {
	1401: [
		{
			id: 4471,
			vehicleId: 1401,
			code: "WO20260818_L174FD",
			issueCount: 3,
			jobCount: 2,
			handoverFlagged: true,
			createdAt: "2026-08-18T05:38:00Z",
			lastUpdatedAt: "2026-08-20T05:38:00Z",
			status: "InWorkshop",
			allowedTransitions: ["CompletedByWorkshop", "Cancelled"],
			addedBy: "someone@getgo.sg",
			workshop: "ABC Workshop",
			completedByWorkshopAt: null,
		},
		{
			id: 4472,
			vehicleId: 1401,
			code: "WO20260818_L17F4E",
			issueCount: 0,
			jobCount: 2,
			createdAt: "2026-08-17T02:15:00Z",
			lastUpdatedAt: "2026-08-21T09:05:00Z",
			status: "Triage",
			allowedTransitions: ["Cancelled", "InWorkshop"],
			addedBy: "jane.tan@getgo.sg",
			workshop: "ABC Workshop",
			completedByWorkshopAt: null,
		},
		{
			id: 4475,
			vehicleId: 1401,
			code: "WO20260825_QK92LM",
			issueCount: 1,
			jobCount: 0,
			createdAt: "2026-08-20T03:00:00Z",
			lastUpdatedAt: "2026-08-20T03:00:00Z",
			status: "InProgress",
			allowedTransitions: ["Cancelled"],
			addedBy: "cx.agent@getgo.sg",
			workshop: null,
			completedByWorkshopAt: null,
		},
		{
			id: 4476,
			vehicleId: 1401,
			code: "WO20260827_JT44RS",
			issueCount: 2,
			jobCount: 0,
			createdAt: "2026-08-26T07:00:00Z",
			lastUpdatedAt: "2026-08-27T09:00:00Z",
			status: "InWorkshop",
			allowedTransitions: ["CompletedByWorkshop", "Cancelled"],
			addedBy: "ops.lead@getgo.sg",
			workshop: "Workshop ABC",
			completedByWorkshopAt: null,
		},
	],
	1402: [
		{
			id: 4473,
			vehicleId: 1402,
			code: "WO20260818_L17F4F",
			issueCount: 1,
			jobCount: 2,
			createdAt: "2026-08-19T11:50:00Z",
			lastUpdatedAt: "2026-08-19T11:50:00Z",
			status: "Triage",
			allowedTransitions: ["Cancelled"],
			addedBy: "wei.ming@getgo.sg",
			workshop: "ABC Workshop",
			completedByWorkshopAt: null,
		},
		{
			id: 4474,
			vehicleId: 1402,
			code: "WO20260818_L17F4G",
			issueCount: 1,
			jobCount: 2,
			createdAt: "2026-08-16T14:22:00Z",
			lastUpdatedAt: "2026-08-22T17:40:00Z",
			status: "Triage",
			allowedTransitions: ["Cancelled"],
			addedBy: "someone@getgo.sg",
			workshop: "ABC Workshop",
			completedByWorkshopAt: null,
		},
	],
	// Real UAT work order, so adding issues to it hits the live API.
	20209: [
		{
			id: 43,
			vehicleId: 20209,
			code: "WO20261014_W97G3B",
			issueCount: 5,
			jobCount: 0,
			createdAt: "2026-10-14T00:00:00Z",
			lastUpdatedAt: "2026-10-14T00:00:00Z",
			status: "Triage",
			allowedTransitions: ["InProgress", "InWorkshop", "Cancelled"],
			addedBy: "",
			workshop: null,
			completedByWorkshopAt: null,
		},
	],
};

export const mockWorkOrders = Object.values(mockWorkOrdersByVehicle).flat();
